import { compose, withHandlers } from "recompose";
import { connect } from "react-redux";
import { isAnonymousUser } from "src/modules/auth/duck/selectors";

import Success from "./Success";

function mapStateToProps(state) {
  return {
    isAnonymousUser: isAnonymousUser(state)
  };
}

const enhance = compose(
  connect(mapStateToProps),
  withHandlers({
    onContinue:
      ({ flow, isAnonymousUser, onClose }) =>
      () =>
        isAnonymousUser ? flow.push("set-up-account") : onClose()
  })
);
export default enhance(Success);
